var exports = {
  "eo": "AuthLoginMethodPicker.module__methodList___QzByb3",
  "g2": "AuthLoginMethodPicker.module__methodPrimary___QzByb3",
  "Ao": "AuthLoginMethodPicker.module__methodSecondaryGrid___QzByb3",
  "JP": "AuthLoginMethodPicker.module__methodFooter___QzByb3",
};

module.exports = exports;
